<div>
  <span *ngIf="isOrderWithSubscription()">
    {{ 'HISTORY.BENEFIT.ORDER_WITH_SUBSCRIPTION_INFO' | translate }}
    {{ benefit.subscriptionActualOrders }}/{{ benefit.subscriptionExpectedOrders }}
  </span>
  <div *ngIf="isOrderWithAutoOrder()">
    <span
      *ngIf="benefit.isAutoOrderEnabled === true && benefit.isAutoOrderDynamic === false; else autoOrderWithDynamicQuantity;">
      {{ 'HISTORY.BENEFIT.ORDER_WITH_ACTIVE_AUTO_ORDER_INFO' | translate }}
      ({{ benefit.noOfUnits }} {{ 'HISTORY.BENEFIT.UNITS' | translate }})
    </span>
    <ng-template #autoOrderWithDynamicQuantity>
      <ng-container
        *ngIf="benefit.isAutoOrderEnabled === true && benefit.isAutoOrderDynamic === false; else inactiveAutoOrder">
        <span>
          {{ 'HISTORY.BENEFIT.ORDER_WITH_ACTIVE_AUTO_ORDER_DYNAMIC_INFO' | translate }}
        </span>
      </ng-container>
    </ng-template>
    <ng-template #inactiveAutoOrder>
      <span *ngIf="benefit.isAutoOrderEnabled === false">
        {{ 'HISTORY.BENEFIT.ORDER_WITH_INACTIVE_AUTO_ORDER_INFO' | translate }}
      </span>
    </ng-template>
  </div>
  <span *ngIf="isAutoOrder()">
    {{ 'HISTORY.BENEFIT.AUTO_ORDER_INFO' | translate }}
  </span>
  <span *ngIf="isSubscription()">
    {{ 'HISTORY.BENEFIT.SUBSCRIPTION_INFO' | translate }}
  </span>
</div>
